<div class="fixed bottom-0 left-0 right-0 m-l am-flex-align toaster-wrapper">
  @for (toast of toasts; track toast) {
    <div class="am-flex-align am-flex-justify gap-m p-xs pt-xxs pb-xxs width-full color-white fade-in"
        [class.fade-out]="toast.fade"
        [ngClass]="toast.type ? 'bg-'+toast.type + ' b-'+toast.type : 'bg-blue b-blue'">
      <span class="text-m" [innerHTML]='toast.message'></span>
      <span class="icon-cross am-flex-center font-small-icon" (click)="removeToast(toast)"></span>
    </div>
  }
</div>
